/******************************************************************************************
 *	Licensing Admins Service
 ********************************************************************************************/
(function() {


  angular.module('rcServices.licensingAdmins', []).service(
    'LicensingAdmins',
    /* @ngInject */
    function(jilLicensingAdmins) {
      this.getAll = function() {
        return jilLicensingAdmins.licensingAdmins.query().$promise;
      };

      this.add = function(payload) {
        return jilLicensingAdmins.licensingAdmins.save({}, payload).$promise;
      };

      this.updateRole = function(userId, payload) {
        return jilLicensingAdmins.licensingAdminRole.update({userId: userId}, payload).$promise;
      };

      this.remove = function(userId, role) {
        return jilLicensingAdmins.licensingAdmin.delete({userId: userId, role: role}).$promise;
      };
    }
  );
})();